var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('my-login')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d46ff06","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 629
// module chunks = 2